import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: any, option) {
    const { sessionConsultant } = option || {};
    let options: AbstractControlOptions = {};
    const formConfig = {
      ownerId: [entity?.ownerId],
      productId: [entity?.productId],

      lmnpInvestmentAmount: [
        entity?.lmnpInvestmentAmount || null,
        Validators.required,
      ],
      lmnpTaxReductionAmount: [
        entity?.lmnpTaxReductionAmount || null,
        sessionConsultant ? Validators.required : Validators.nullValidator,
      ],
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
